export const getInitialState = (): any => ({
  snowflakeGetQueryData: {},
  snowflakeGetQueryStatus: 0
});